<template>
	<v-menu
		v-model="status_tooltip"
		:close-on-content-click="false"
		:nudge-width="400"
		offset-y
	>
		<template v-slot:activator="{ attrs, on }">
			<span class="custom-icon" v-bind="attrs" v-on="on">
				<img
					src="@/assets/img/icon-info1.svg"
					alt="Status Info"
					width="16"
					height="auto"
				/>
			</span>
		</template>

		<div class="status-tooltip py-3 px-6">
			<button
				class="status-tooltip-close"
				@click="status_tooltip = false"
			>
				<img
					src="@/assets/img/icon-close1.svg"
					alt="Close Status Info"
					width="16"
					height="auto"
				/>
			</button>
			<ul>
				<li
					v-for="statusKey in Object.keys(statuses_info)"
					:key="statusKey"
				>
					<strong>{{
						statuses[statusKey]
							? statuses[statusKey]
							: statusKey.charAt(0).toUpperCase() +
							  statusKey.slice(1).toLowerCase()
					}}</strong>
					-
					{{ statuses_info[statusKey].description }}
				</li>
			</ul>
		</div>
	</v-menu>
</template>

<script>
import { LEAD_STATUSES, LEAD_STATUSES_INFO } from "@/constants";

export default {
	name: "StatusTooltip",
	data() {
		return {
			status_tooltip: false,
			statuses: LEAD_STATUSES,
			statuses_info: LEAD_STATUSES_INFO,
		};
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";

.v-menu__content:has(.status-tooltip) {
	font-size: 13px;
	background: #efefef;
	color: darken($purple, 12%);
	margin-top: 20px;
	border: 0 !important;
	ul {
		display: block;
		margin: 0;
		padding: 0;
		list-style: none;
		li {
			display: block;
			margin: 0.2em 0;
		}
	}
	.status-tooltip-close {
		background: darken($purple, 12%);
		display: block;
		margin: auto;
		margin-right: -10px;
		padding: 3px;
		border-radius: 3px;
		img {
			display: block;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StatusTooltip.vue